import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useWebSocket, {ReadyState} from 'react-use-websocket';
import Api from 'constants/Api';
import {purifyMessage} from '../../helpers/UrlHelper';

import * as TradeActions from 'redux/actions/TradeActions';
import * as WalletActions from 'redux/actions/WalletActions';

import ReactHtmlParser from 'react-html-parser';
import _ from 'lodash';
import Message from 'components/common/Message'

export const useSocketSystem = () => {
    const dispatch = useDispatch();

    const AuthState = useSelector((state) => state.Auth);
    const TradeMarkets = useSelector((state) => state.Trade.markets);
    const Wallet = useSelector((state) => state.Wallet);

    const {
        lastMessage: webSocketService,
        sendJsonMessage: sendWebsocket,
        readyState,
        getWebSocket,
    } = useWebSocket(`${Api.SOCKET_PROTOCOL}${Api.SOCKET_URL}/ws/`, {
        onOpen: () => console.log('Layout websocket connected'),
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => {
            return true
        },
        share: true
    });

    useEffect(() => {
        /**
         * Send request to websocket service
         */
        if (readyState === ReadyState.OPEN) {
            if (AuthState.token) {
                sendWebsocket({
                    "action": "subscribe_user_balance",
                    "params": {
                        "token": AuthState.token
                    }
                });

                sendWebsocket({
                    "action": "subscribe_crypto_balance",
                    "params": {
                        "token": AuthState.token
                    }
                });

                sendWebsocket({
                    "action": "subscribe_user_notifications",
                    "params": {
                        "token": AuthState.token
                    }
                });
            }

            sendWebsocket({
                "action": "subscribe_coins_prices"
            })

            if (_.isEmpty(TradeMarkets)) {
                dispatch(TradeActions.handleGetMarkets(null))
            }
        }
    }, [readyState, AuthState]);

    useEffect(() => {
        if (webSocketService !== null) {
            let websocket = JSON.parse(webSocketService.data);

            if (typeof websocket.data !== "undefined" && websocket.subscribe === 'user_balance') {
                let userBalance = websocket.data;
                if (!_.isEmpty(userBalance)) {
                    dispatch(WalletActions.handleSetFiatBalance({
                        balance: userBalance?.confirmed_balance,
                        blockedBalance: userBalance?.blocked_balance
                    }));
                }
            }

            if (typeof websocket.data !== "undefined" && websocket.subscribe === 'crypto_balance' && typeof Wallet?.cryptoWallets !== "undefined") {
                let cryptoBalance = websocket.data;
                dispatch(WalletActions.handleSpecificWalletBalance(cryptoBalance))
            }

            if (typeof websocket.data !== "undefined" && websocket.subscribe === 'user_notifications') {
                let notificationData = websocket.data;

                try {
                    Message({
                        type: 'success',
                        text: ReactHtmlParser(purifyMessage(notificationData.description).withHtml),
                        duration: 10
                    })

                    new Notification(purifyMessage(notificationData.description).withOutHtml)
                } catch (e) {
                    console.log(e)
                }
            }

            if (webSocketService !== null) {
                let websocket = JSON.parse(webSocketService.data);

                if (typeof websocket.data !== 'undefined' && websocket.subscribe === 'coins_prices') {
                    let prices = websocket.data;
                    dispatch(TradeActions.handleSetMarketPrices(prices))
                }
            }
        }
    }, [webSocketService])

    // useEffect(() => {
    //     return () => {
    //         if (!_.isNull(getWebSocket))
    //             getWebSocket().close()
    //     }
    // }, [])

}